import { Apis } from "../../../lib/Apis";

export const useCategoryProducts = () => {
    const getCategoryProducts = async (id, setCategoryProducts) => {
        try {
            const response = await Apis.getCategoryProducts(id);
            if (response && response.data && Array.isArray(response.data.products)) {
                setCategoryProducts(response.data.products);
            } else {
                console.error("Invalid response format:", response);
                setCategoryProducts([]);
            }
        } catch (error) {
            console.error("Error in Hook:", error.message || error);
            setCategoryProducts([]);
        }
    };

    // New paginated version of getCategoryProducts
    const getCategoryProductsWithPagination = async (id, setCategoryProducts, setTotal, offset = 0, limit = 10, name = "", status = "") => {
        try {
            const params = {};
            
            if (name) {
                params.name = name;
            }
            
            if (status !== "") {
                params.status = status === "true" ? true : false;
            }

            const response = await Apis.getCategoryProductsWithPagination(id, offset, limit, params);
            if (response?.status === 200) {
                setCategoryProducts(response.data.products);
                // Extract total from pagination object
                const totalRecords = response.data.pagination?.totalRecords || response.data.products.length;
                setTotal(totalRecords);
                return response;
            } else {
                throw new Error(response?.data?.message || "Failed to fetch category products.");
            }
        } catch (error) {
            console.error("Error fetching category products:", error);
            throw new Error(error.message || "Error fetching category products.");
        }
    };

    const searchCategoryProducts = async (id, name, status, offset = 0, limit = 10) => {
        try {
            const params = {};
            
            if (name) {
                params.name = name;
            }
            
            if (status !== "") {
                params.status = status === "true" ? true : false;
            }

            const response = await Apis.getCategoryProductsWithPagination(id, offset, limit, params);
            return response.data;
        } catch (error) {
            console.error("🚀 ~ file: useHook.js ~ line 64 ~ searchCategoryProducts ~ error", error);
            return error;
        }
    };

    return {
        getCategoryProducts,
        getCategoryProductsWithPagination,
        searchCategoryProducts
    };
};
